module.exports = __webpack_public_path__ + "static/media/emma.b967ee63.png";